export enum AlertsPeriod {
  None,
  Daily,
  Weekly,
  Monthly,
  Yearly,
}

export class AlertsConfig {
  period: AlertsPeriod;
  startDateTime: Date;
  endDateTime: Date;
  daysOfMonth: number[];
  months: number[];
  daysOfWeek: number[];
  individualSettings: any[];
  timeShown?: boolean;
  hours?: number;
  minutes?: number;
}
